// @ts-check

/**
 * Returns the keys of an object as a typed array of keys. Unlike the default Object.keys,
 * this preserves the actual key type (K) instead of always using string, making it safer
 * and more accurate for enums and objects with specific key types.
 *
 * @template {string} K
 * @template V
 * @param {Record<K, V>} obj
 * @returns {K[]}
 */
export const typedKeys = (obj) => /** @type {K[]} */(Object.keys(obj));

/**
 * Returns the entries of an object as a typed array of [key, value] pairs. Unlike the default
 * Object.entries, this preserves the actual key type (K) instead of always using string, making
 * it safer and more accurate for enums and objects with specific key types.
 *
 * @template {string} K
 * @template V
 * @param {Record<K, V>} obj
 * @returns {[K, V][]}
 */
export const typedEntries = (obj) => /** @type {[K, V][]} */(Object.entries(obj));
